const Config = {
	buildVersion: "20240521.1",
	releaseVersion: "1.0.3",
	environment: "development",
	dexieVersion: 8,
};

export default Config;
